import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Modal, notification } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import 'antd/dist/antd.css';

const { Title } = Typography;

@inject('RoomTypeStore')
@observer
class RoomTypeListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.RoomTypeStore.initRoomType();
    }

    // ON CLICK

    deleteRoomTypeOnClick = (roomTypeId) => {
        Modal.confirm({
            title: 'Delete Room Type',
            content: 'Are you sure to delete this room type?',
            okText: 'Yes',
            cancelText: 'Cancel',
            onOk: () => { this.deleteRoomTypeOnOk(roomTypeId); }
        });
    }

    // ON OK

    deleteRoomTypeOnOk = (roomTypeId) => {
        this.props.RoomTypeStore.deleteRoomType(roomTypeId).then(response => {
            if (!response.isError) {
                notification['success']({
                    message: 'Success',
                    description: 'Room type has been successfully updated.',
                    duration: 3
                });
            } else {
                notification['error']({
                    message: 'Error',
                    description: response.errorMessage,
                    duration: 3
                });
            }
        });
    }

    // TABLE SETTING

    getColumns = () => {
        return [
            {
                title: 'Room Type',
                dataIndex: 'roomTypeName',
                key: 'roomTypeName',
                ...this.getColumnSearchProps('roomTypeName')
            },
            {
                title: 'Action',
                dataIndex: 'roomTypeId',
                key: 'roomTypeId',
                render: roomTypeId => (
                    <span>
                        <Button onClick={() => this.props.RoomTypeStore.initUpdateRoomType(roomTypeId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteRoomTypeOnClick(roomTypeId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const {
            roomTypes,
            roomTypeListLoading
        } = this.props.RoomTypeStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>List</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={() => this.props.RoomTypeStore.initCreateRoomType()}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Spin spinning={roomTypeListLoading}>
                        <Table columns={this.getColumns()} dataSource={roomTypes} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default RoomTypeListPage;